import { render, staticRenderFns } from "./label-print.vue?vue&type=template&id=6d61cce4&scoped=true"
import script from "./label-print.vue?vue&type=script&lang=js"
export * from "./label-print.vue?vue&type=script&lang=js"
import style0 from "./label-print.vue?vue&type=style&index=0&id=6d61cce4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d61cce4",
  null
  
)

export default component.exports